import Vue from 'vue'
import App from './App'
import router from './router'
import VueCharts from 'vue-charts'
import VueAdsense from 'vue-adsense'
import 'vue-awesome/icons/circle-o-notch'
import Icon from 'vue-awesome/components/Icon'

Vue.config.productionTip = false

Vue.use(VueCharts)
Vue.component('adsense', VueAdsense)
Vue.component('icon', Icon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js